/**
 * @Author wuTao
 * @description 类型新增编辑页面
 * @Date 2023/04/11
 */
import React from 'react';
import {connect} from 'dva';
import {component_tool, framework_tool, utils_tool} from '@/tool'
import {Spin} from "antd";
import '@/styles/containers/proKnowledge/knowledgeType/style.less'
import {columnsBase, columnsHighSet, columnsProperty} from './columns';

let {WizContainer, modelUtils} = framework_tool;

let {
  WizCard, WizSelect, WizSwitch, WizForm, WizSpin, WizModal, WizButton, WizIcon,
  WizDropdown, WizMenu, WizTable, WizRow, WizCol, WizRadio, WizDatePicker, WizTooltip, Wizmessage, WizLayout, WizCheckbox
} = component_tool;

const {Sider, Content} = WizLayout;
let {Session} = utils_tool;

const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    //查看
    if (history.location.pathname === '/proKnowledge/knowledgeTypeList/add') {
      if (history.location && history.location.record) {
        record = history.location.record
        Session.set('knowledgeTypeDetailAddInfo', record)
      } else {
        record = Session.get('knowledgeTypeDetailAddInfo') || {}
      }
    } else if (history.location.pathname === '/proKnowledge/knowledgeTypeList/update') {
      //审核 1
      if (history.location && history.location.record) {
        record = history.location.record
        Session.set('knowledgeTypeDetailUpdateInfo', record)
      } else {
        record = Session.get('knowledgeTypeDetailUpdateInfo') || {}
      }
    }
  }
  return record
}

class KnowledgeTypeDetail extends WizContainer {

  componentName = 'KnowledgeTypeDetail';

  constructor(props) {
    super(props);
    super(props);
    const {history} = props;
    let record = getParamRecord(history)
    let initialValue = record;
    let contentTypeList = (record && record.contentTypeList) ? record.contentTypeList : [];
    let isShowFileTypeList = false;
    let isShowTextContent = false;
    let isShowBusiness = false;
    if (contentTypeList && contentTypeList instanceof Array && contentTypeList.length > 0) {
      contentTypeList.forEach(item => {
        if (item === 1) {
          isShowFileTypeList = true;
        }
        if (item === 2) {
          isShowTextContent = true;
        }
        if (item === 3) {
          isShowBusiness = true;
        }
      });
    }
    this.state = {
      record: record,
      propertyList: [],
      propertyIdList: [],
      isShowFileTypeList: isShowFileTypeList,
      isShowTextContent: isShowTextContent,
      isShowBusiness : isShowBusiness,
    };
    this.initialValue = initialValue;
  }


  _componentDidMount() {
    //默认直接获取属性信息
    this.getKnowledgeTypePropertyList({type: 1, state: 1});
    // if (this.initialValue && this.initialValue.id) {
    //   this.getKnowledgeTypeDetailInfo({id: this.initialValue.id});
    // } else {
    //   this.getKnowledgeTypePropertyList({type: 1, state: 1});
    // }
  }


  /**
   * 获取人员认证信息
   */
  getKnowledgeTypeDetailInfo = (apiParams = {}) => {
    this.doAction({
      path: 'proKnowledgeType/getOneById',
      payload: {
        key: "proKnowledgeType@getOneById",
        apiParams
      }
    })
  }
  /**
   * 获取属性列表信息
   */
  getKnowledgeTypePropertyList = (apiParams = {}) => {
    this.doAction({
      path: 'proKnowledgeType/propertyList',
      payload: {
        key: "proKnowledgeType@propertyList",
        apiParams
      }
    })
  }
  propsAndStateOnChange = {
    addKnowledgeType: this._addKnowledgeTypeOver.bind(this),
    updateKnowledgeType: this._updateKnowledgeTypeOver.bind(this),
    propertyListKnowledgeType: this._propertyListKnowledgeTypeOver.bind(this),
    knowledgeTypeOneInfo: this._knowledgeTypeOneInfoOver.bind(this),
  };

  /**
   * 获取属性列表成功返回原页面，失败弹出提示
   */
  _knowledgeTypeOneInfoOver(nextProps, nextState) {
    if (nextProps.knowledgeTypeOneInfo.code == 1) {
      let record = nextProps.knowledgeTypeOneInfo.data;
      nextState.record = record;
      this.initialValue = record;
    } else {
      wizNotice.error('获取属性列表失败：' + nextProps.knowledgeTypeOneInfo.msg);
    }
    return true;
  }

  /**
   * 获取属性列表成功返回原页面，失败弹出提示
   */
  _propertyListKnowledgeTypeOver(nextProps, nextState) {
    if (nextProps.propertyListKnowledgeType.code == 1) {
      let propertyList = nextProps.propertyListKnowledgeType.data;
      nextState.propertyList = propertyList;
      let propertyIdList = [];
      if (propertyList && propertyList.length > 0) {
        propertyList.forEach(e => {
          const {id} = e;
          propertyIdList.push(id);
        })
        nextState.propertyIdList = propertyIdList;
        this.formDataBase.setFieldsValue({
          typePropertyIdList: propertyIdList
        });
      } else {
        nextState.propertyIdList = [];
      }
    } else {
      nextState.propertyIdList = [];
      wizNotice.error('获取属性列表失败：' + nextProps.propertyListKnowledgeType.msg);
    }
    return true;
  }

  /**
   * 知识类型新增成功返回原页面，失败弹出提示
   */
  _addKnowledgeTypeOver(nextProps, nextState) {
    if (nextProps.addKnowledgeType.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/proKnowledge/knowledgeTypeList');
    } else {
      wizNotice.error('保存失败：' + nextProps.addKnowledgeType.msg);
    }
    return true;
  }

  /**
   * 知识类型修改成功返回原页面，失败弹出提示
   */
  _updateKnowledgeTypeOver(nextProps, nextState) {
    if (nextProps.updateKnowledgeType.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/proKnowledge/knowledgeTypeList');
    } else {
      wizNotice.error('保存失败：' + nextProps.updateKnowledgeType.msg);
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (key === 'imgRandom') {
        if (value === null || value === undefined || !value) {
          fitterValues[key] = 1;
        } else {
          fitterValues[key] = 0;
        }
      } else if (key === 'endDate' && value != null && value != undefined) {
        fitterValues[key] = value.format("YYYY-MM-DD HH:mm:ss");
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    return fitterValues;
  }

  /**
   * 保存/更新 知识类型
   * @param values
   * @private
   */
  _saveKnowledgeType() {
    let initialValue = this.initialValue;
    let isAdd = initialValue && initialValue.id ? false : true;
    let propertyIdList = this.state.propertyIdList;
    this.formDataBase.validateFields((err, values) => {
      let baseFitterValues = this.fitterFieldsValue(values);
      if (!err) {
        //TODO 校验通过进行下一步
        this.formDataHighSet.validateFields((err, values) => {
          if (!err) {
            let highSetFitterValues = this.fitterFieldsValue(values);
            if (highSetFitterValues['contentTypeList']) {
              let valueValidate = highSetFitterValues['contentTypeList'];
              if (valueValidate && valueValidate instanceof Array && valueValidate.length) {
                let contentTypeIsFile = false;
                valueValidate.forEach(fileType => {
                  if (1 === fileType) {
                    contentTypeIsFile = true;
                  }
                })
                if (contentTypeIsFile) {
                  let fileTypeList = highSetFitterValues['fileTypeList'];
                  if (!fileTypeList || !(fileTypeList instanceof Array) || fileTypeList.length <= 0) {
                    this.formDataHighSet.setFields({
                      'fileTypeList': {
                        value: values['fileTypeList'],
                        errors: [
                          new Error("请选择文件支持格式")
                        ]
                      }
                    });
                    return
                  }
                }
              }
            }
            //TODO 校验通过进行下一步
            let allFitterValues = {...baseFitterValues, ...highSetFitterValues};
            if (isAdd) {
              this.doAction({
                path: 'proKnowledgeType/add',
                payload: {
                  key: 'addKnowledgeType',
                  apiParams: {...allFitterValues}
                }
              })
            } else {
              this.doAction({
                path: 'proKnowledgeType/update',
                payload: {
                  key: 'updateKnowledgeType',
                  apiParams: {...allFitterValues, id: initialValue.id}
                }
              })
            }
          }
          return
        });
      } else {
        if (err) {
          const {typePropertyIdList} = err;
          if (typePropertyIdList && typePropertyIdList.errors && typePropertyIdList.errors instanceof Array && typePropertyIdList.errors.length > 0) {
            const {message, field} = typePropertyIdList.errors[0];
            this.formDataBase.setFields({
              'typePropertyIdList': {
                value: values['typePropertyIdList'],
                errors: [
                  new Error(message)
                ]
              }
            });
          }
        }
      }
      return
    });
  }

  /**基础设置 */
  _getKnowledgeBase() {
    let {record} = this.state;
    let formProps = {
      ref: 'formDataBase',
      columns: columnsBase(),
      record: record,
      preview: null,
      footer: [],
      formItemLayout: {
        labelCol: {span: 7},
        wrapperCol: {span: 17}
      }
    }
    let cardProps = {
      headStyle: {backgroundColor: '#ffffff', color: '#3a3a3a'},
      bordered: true,
      bodyStyle: {minHeight: '300px', width: '95%', marginTop: 25}
    }
    return (
      <WizCard {...cardProps} tabList={[{key: '基础设置', tab: '基础设置'}]}>
        <WizForm className={'form-inline'} {...formProps}
                 ref={r => {
                   this.formDataBase = r
                 }}/>
      </WizCard>
    )
  }

  /**类型属性 */
  _getKnowledgeProperty() {
    let {propertyList} = this.state;
    let cardProps = {
      headStyle: {backgroundColor: '#ffffff', color: '#3a3a3a'},
      bordered: true,
      bodyStyle: {minHeight: '300px', width: '95%', marginTop: 25}
    }
    const tableProps = {
      pagination: false,
      columns: columnsProperty(),
      dataSource: propertyList || [],
      bordered: true,
      rowKey: "id",
      isScroll: false,
    };
    return (
      <WizCard {...cardProps} tabList={[{key: '属性配置', tab: '属性配置'}]}>
        <WizTable {...tableProps} />
      </WizCard>
    )
  }

  _getCheckbox(value, name, fileTypeList = []) {
    let defaultChecked = false;
    let disabled = false;
    if (fileTypeList && fileTypeList.length > 0) {
      fileTypeList.forEach(e => {
        if (e === value) {
          defaultChecked = true;
          disabled = true;
        }
      })
    }
    return (
      <WizCol span={6}><WizCheckbox value={value} defaultChecked={defaultChecked}
                                    disabled={disabled}>{name}</WizCheckbox></WizCol>
    )
  }

  /**类型高级设置 */
  _getKnowledgeHighSet() {
    let {propertyList} = this.state;
    let {record} = this.state;
    let minHeight = propertyList && propertyList.length > 0 ? '965px' : '720px';
    let self = this;
    let formProps = {
      ref: 'formDataHighSet',
      columns: columnsHighSet(self, {propertyList}),
      record: record,
      preview: null,
      footer: [],
      formItemLayout: {
        labelCol: {span: 6},
        wrapperCol: {span: 17}
      }
    }
    let cardProps = {
      headStyle: {backgroundColor: '#ffffff', color: '#3a3a3a'},
      bordered: true,
      bodyStyle: {minHeight: minHeight}
    }
    return (
      <WizCard {...cardProps} tabList={[{key: '高级设置', tab: '高级设置'}]}>
        <WizForm className={'form-inline'} {...formProps}
                 ref={r => {
                   this.formDataHighSet = r
                 }}/>
      </WizCard>
    )
  }

  _render() {
    const {proKnowledgeTypeLoading} = this.props;
    let {record} = this.state;
    return (
      <div>
        <Spin tip={'加载中'} spinning={proKnowledgeTypeLoading}>
          <div className='knowledge-type'>
            <WizRow className='knowledge-div-button' gutter={[8, 16]}>
              <WizCol>
                <WizRow className='knowledge-row' align={'middle'} justify={'center'}>
                  <WizCol offset={22}><WizButton className={'knowledge-group-button'}
                                                 onClick={e => this._saveKnowledgeType()}>保存</WizButton></WizCol>
                </WizRow>
              </WizCol>
            </WizRow>
            <WizRow className='knowledge-div-row' gutter={[8, 16]}>
              <WizCol>
                <WizRow gutter={[8, 16]}>
                  <WizCol span={10} className='knowledge-col'>
                    <div>
                      <WizRow gutter={[16, 16]}>
                        <WizCol>
                          {this._getKnowledgeBase()}
                        </WizCol>
                      </WizRow>
                      <WizRow gutter={[16, 16]}>
                        <WizCol>
                          {this._getKnowledgeProperty()}
                        </WizCol>
                      </WizRow>
                    </div>
                  </WizCol>
                  <WizCol span={14} className='knowledge-col'>
                    {this._getKnowledgeHighSet()}
                  </WizCol>
                </WizRow>
              </WizCol>
            </WizRow>
          </div>
        </Spin>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {proKnowledgeType} = state;
  const addKnowledgeType = modelUtils.getModelEntity(proKnowledgeType, "addKnowledgeType");
  const updateKnowledgeType = modelUtils.getModelEntity(proKnowledgeType, "updateKnowledgeType");
  const propertyListKnowledgeType = modelUtils.getModelEntity(proKnowledgeType, "proKnowledgeType@propertyList");
  const knowledgeTypeOneInfo = modelUtils.getModelEntity(proKnowledgeType, "proKnowledgeType@getOneById");
  const load = modelUtils.getLoadingState(state, ['proKnowledgeType']);
  return {
    addKnowledgeType: addKnowledgeType,
    updateKnowledgeType: updateKnowledgeType,
    propertyListKnowledgeType: propertyListKnowledgeType,
    knowledgeTypeOneInfo: knowledgeTypeOneInfo,
    ...load
  }
};

export default connect(mapStateToProps)(KnowledgeTypeDetail);
